var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHousing(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 526,
    height: 478,
    viewBox: "0 0 526 478",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M82.2721 147.352L173.142 158.089L183.964 214.564L190.363 247.954L174.952 233.61L128.927 283.061L51.6523 211.141L97.6771 161.69L82.2721 147.352Z",
    stroke: "#6F7C87",
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M136.058 153.31L145.815 142.827L133.098 130.992L114.5 150.975",
    stroke: "#6F7C87",
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M81.3064 237.468L104.518 212.529L122.285 229.064L99.0731 254.004L81.3064 237.468Z",
    stroke: "#6F7C87"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M80.5654 237.518L104.502 211.8L119.846 226.08",
    stroke: "#6F7C87",
    strokeMiterlimit: 10
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M99.0543 254.725L122.991 229.007L107.648 214.728",
    stroke: "#6F7C87",
    strokeMiterlimit: 10
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M394.083 306.605C394.083 328.089 394.056 347.859 394.029 362.293C394.016 369.566 394.002 375.484 393.992 379.584C393.987 381.634 393.983 383.229 393.98 384.312L393.976 385.545L393.975 385.859L393.975 385.939L393.975 385.959L393.975 385.964V385.965C393.975 385.965 393.975 385.966 394.475 385.967L393.975 385.966V385.967V434.447L357.764 476.818H312.142V434.991L332.662 418.775L332.852 418.625V418.383V402.017V401.802L332.697 401.654L312.142 382.148V368.336L332.727 345.058L332.852 344.916V344.727V328.36V328.118L332.662 327.968L312.142 311.752V248.788V248.488L311.878 248.347C277.126 229.763 260.37 194.846 260.37 156.317C260.37 98.8513 305.957 53.2644 363.423 53.2644C420.722 53.2644 466.211 98.5871 466.474 155.817H466.457V156.317C466.457 179.922 461.294 202.15 449.711 220.067C438.134 237.975 420.122 251.61 394.354 258.012L393.975 258.106V258.497V306.105V306.605H394.083ZM330.877 125.021C330.877 143.009 345.453 157.585 363.441 157.585C381.429 157.585 396.005 143.009 396.005 125.021C396.005 107.033 381.429 92.4572 363.441 92.4572C345.453 92.4572 330.877 107.033 330.877 125.021Z",
    fill: "#A3C5EB",
    stroke: "#6F7C87"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M394.484 306.123V258.497C446.256 245.636 466.966 203.663 466.966 156.317C466.966 98.5751 421.156 52.7644 363.413 52.7644C305.671 52.7644 259.861 98.5751 259.861 156.317C259.861 194.993 276.687 230.091 311.633 248.788V311.994L332.343 328.36V344.727L311.633 368.147V382.363L332.343 402.017V418.383L311.633 434.749V477.318H357.985L394.466 434.632V385.967C394.466 385.967 384.196 346.298 429.357 346.298H526",
    stroke: "#6F7C87",
    strokeMiterlimit: 10
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M363.417 156.316C380.572 156.316 394.479 142.41 394.479 125.255C394.479 108.1 380.572 94.1936 363.417 94.1936C346.263 94.1936 332.356 108.1 332.356 125.255C332.356 142.41 346.263 156.316 363.417 156.316Z",
    stroke: "#6F7C87",
    strokeMiterlimit: 10
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M240.217 125.272C226.786 112.113 218.45 93.7685 218.45 73.4825C218.45 33.4523 250.902 1 290.932 1C330.962 1 363.415 33.4523 363.415 73.4825V94.193",
    stroke: "#6F7C87",
    strokeMiterlimit: 10
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M197.746 73.4827H135.614L1 208.097L125.263 332.351L239.167 218.448",
    stroke: "#6F7C87",
    strokeMiterlimit: 10
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHousing);
export default __webpack_public_path__ + "static/media/housing.e238e0b1.svg";
export { ForwardRef as ReactComponent };